import { render, staticRenderFns } from "./video.vue?vue&type=template&id=c88ed2a8&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=c88ed2a8&prod&lang=less&scoped=true&"
import style1 from "./video.vue?vue&type=style&index=1&id=c88ed2a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88ed2a8",
  null
  
)

export default component.exports